// Agent state badge — always shows the agent's current state with colour AND a
// text label (accessibility: never colour alone). WCP redesign pass, 2026-09-20.
import { useAgentSession } from '../lib/agentSession';

export default function AgentStateBadge({ className = '' }: { className?: string }) {
  const { state, label, enabled, caption } = useAgentSession();
  if (!enabled && state === 'idle') return null; // invisible when the feature is off

  return (
    <span
      className={`agent-state-badge ${className}`}
      data-agent-state={state}
      data-agent-id="assistant.state.badge"
      role="status"
      aria-live="polite"
      title={caption ?? label}
    >
      <span className="agent-state-dot" aria-hidden="true" />
      {label}
    </span>
  );
}
